// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__F0BJu","col":"styles_col__39g7X","fulfillmentStatus":"styles_fulfillmentStatus__nUysM","emailCol":"styles_emailCol__34kkF"};